import { Outlet, Navigate } from "react-router-dom";

const PaperManagerRoutes = (props) => {
   return props.paperManager ? <Outlet /> : <Navigate to="/login" />;
};

export default PaperManagerRoutes;
